import React from "react";
import { motion } from "framer-motion";

const FeatureHighlight = () => {
  const features = [
    { title: "SMALL BATCH" },
    { title: "HAND TRIMMED" },
    { title: "HANG DRIED" },
    { title: "HAND PACKAGED" },
  ];

  return (
    <div className="bg-black py-20">
      <div className="flex justify-center gap-12 max-w-6xl mx-auto flex-wrap">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.6,
              delay: index * 0.2,
              ease: "easeOut",
            }}
            viewport={{ once: true }}
            className="relative group"
          >
            {/* Outer Border with Gradient */}
            <div className="bg-gradient-to-r from-green-500 to-orange-500 p-1 rounded-lg shadow-lg">
              {/* Inner Card */}
              <div className="bg-black rounded-lg flex items-center justify-center p-6 transition-transform transform group-hover:scale-105">
                <h3 className="text-white text-xl font-bold tracking-wider group-hover:text-green-400">
                  {feature.title}
                </h3>
              </div>
            </div>
            {/* Glow Effect */}
            <motion.div
              className="absolute inset-0 rounded-lg blur-xl opacity-0 group-hover:opacity-100"
              style={{
                background:
                  "radial-gradient(circle, rgba(0,128,0,0.3), transparent)",
              }}
              initial={{ opacity: 0 }}
              whileHover={{ opacity: 1, scale: 1.1 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FeatureHighlight;
